namespace pixi_ui.utility {
    import Texture = PIXI.Texture;
    import IComponent = pixi_ui.component.IComponent;
    import Image = pixi_ui.component.Image;
    import Text = pixi_ui.component.Text;
    import NineSlice = pixi_ui.component.NineSlice;
    import Input = pixi_ui.component.Input;
    import Rect = pixi_ui.component.Rect;
    import Transparency = pixi_ui.component.Transparency;
    import Visibility = pixi_ui.component.Visibility;
    import TextStyleOptions = PIXI.TextStyleOptions;
    import Point = PIXI.Point;

    export class DefaultBuilder implements IBuilder {
        public create(data: any): Element {
            if (!data.rootElement) throw "Key 'rootElement' missing is JSON.";
            let rootElement: Element = this.generateElement(data.rootElement);
            //rootElement.desiredWidth = data.desiredSize[0] as number;
            //rootElement.desiredHeight = data.desiredSize[1] as number;

            return rootElement;
        }

        public generateElement(elementData: any): Element {
            let element: Element = new Element();

            element.name = elementData.name;

            element.type = ElementType[elementData.type] as any;

            if (elementData.layout.constrains) {
                element.widthMax = elementData.layout.constrains.widthMax;
                element.widthMin = elementData.layout.constrains.widthMin;
                element.heightMax = elementData.layout.constrains.heightMax;
                element.heightMin = elementData.layout.constrains.heightMin;
            }

            if (elementData.layout.pivot) {
                element.pivot.set(
                    elementData.layout.pivot[0],
                    elementData.layout.pivot[1]
                );
            }

            if (elementData.layout.anchors) {
                element.anchorTopLeft.set(
                    elementData.layout.anchors[0],
                    elementData.layout.anchors[1]
                );
                element.anchorBottomRight.set(
                    elementData.layout.anchors[2],
                    elementData.layout.anchors[3]
                );
            }

            if (elementData.layout.offsets) {
                element.offsetTopLeft.set(
                    elementData.layout.offsets[0],
                    elementData.layout.offsets[1]
                );
                element.offsetBottomRight.set(
                    elementData.layout.offsets[2],
                    elementData.layout.offsets[3]
                );
            }

            if (elementData.layout.angle) {
                element.rotation = elementData.layout.angle;
            }

            // Add element components.
            if (elementData.components && elementData.components.length > 0) {
                elementData.components.map((componentData: any) => {
                    element.add(this.generateComponent(componentData));
                });
            }

            // Add element children (recursively).
            if (elementData.children && elementData.children.length > 0) {
                elementData.children.map((elementData: any) => {
                    element.addChild(this.generateElement(elementData));
                });
            }
            return element;
        }

        public generateComponent(componentData: any): IComponent {
            if (componentData.type === undefined)
                'Component type not specified.';

            let component: IComponent;
            let atlas: any = PIXI.loader.resources['atlas_1'];
            let texture: Texture;

            switch (componentData.type) {
                case 'image':
                    texture = atlas.textures[componentData.data.cacheKey];
                    return new Image(texture);
                    break;
                case 'nineslice':
                    texture = atlas.textures[componentData.data.cacheKey];
                    return new NineSlice(texture, {
                        top: componentData.data.offset[0],
                        right: componentData.data.offset[1],
                        bottom: componentData.data.offset[2],
                        left: componentData.data.offset[3],
                    });
                    break;
                case 'text':
                    let options: TextStyleOptions = {};
                    let style: any = componentData.data.style;
                    if (style) {
                        if (style.style) options.fontStyle = style.style;
                        if (style.font) options.fontFamily = style.font;
                        if (style.fontSize) options.fontSize = style.fontSize;
                        if (style.fill) options.fill = style.fill;
                        if (style.stroke) options.stroke = style.stroke;
                        if (style.strokeThickness)
                            options.strokeThickness = style.strokeThickness;
                        if (style.lineSpacing)
                            options.lineHeight = style.lineSpacing;
                        if (componentData.data.align)
                            options.align = componentData.data.align;
                        if (componentData.data.textWrap)
                            options.wordWrap = componentData.data.textWrap;
                        if (componentData.data.maxWidth)
                            options.wordWrapWidth = componentData.data.maxWidth;
                    }

                    return new Text(
                        this.getTextLocalized(
                            componentData.data.textLocalizationKey
                        ),
                        options
                    );

                    break;
                case 'input':
                    return new Input(componentData.data.enabled);
                    break;
                case 'rect':
                    return new Rect(
                        componentData.data.color[2] |
                            (componentData.data.color[1] << 8) |
                            (componentData.data.color[0] << 16),
                        componentData.data.color[3] / 255
                    );
                    break;
                case 'transparency':
                    return new Transparency(componentData.data.alpha);
                    break;
                case 'visibility':
                    return new Visibility(componentData.data.hidden);
                    break;
            }

            throw `Component type ${componentData.type} not implemented.`;
        }

        getTextLocalized(textLocalizationKey: string): string {
            return `${textLocalizationKey}`;
        }

        getTexture(cacheKey: string): PIXI.Texture {
            return PIXI.Texture.WHITE;
        }
    }
}
